module.exports = __webpack_public_path__ + "static/media/orange.fb823bf0.svg";